export default [
    {
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/react.svg",
        title: "React",
        description: "It is an open source JavaScript library focused on creating user interfaces on web pages.",
    },
    {
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/html.svg",
        title: "HTML",
        description: "It is a markup language used in building web pages.",
    },
    {
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/css.svg",
        title: "CSS",
        description: "Cascading Style Sheets is a mechanism for adding style to a web document.",
    },
    {
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/sass.svg",
        title: "Sass",
        description: "It is a stylesheet language initially conceived by Hampton Catlin and developed by Natalie Weizenbaum.",
    },
    {
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/styled-components-1.svg",
        title: "Styled Components",
        description: "It is a library that makes it possible to write CSS code inside JavaScript.",
    },
    {
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/javascript-1.svg",
        title: "JavaScript",
        description: "It is a structured, multi-paradigm, weak dynamically typed, high-level scripting interpreted programming language.",
    },
    {
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/php.svg",
        title: "PHP",
        description: "It is a free interpreted language, originally used only for the development of applications present and acting on the server side.",
    },
    {
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/node.svg",
        title: "NodeJs",
        description: "It is open-source, cross-platform software, and allows you to run JavaScript code outside of a web browser.",
    },
    {
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/mysql.svg",
        title: "MySQL",
        description: "It is a database management system, which uses the SQL language as an interface.",
    },
    {
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/sql-server.svg",
        title: "SQL Server",
        description: "It is a relational database management system developed by Sybase in partnership with Microsoft.",
    },
    {
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/postgresq.svg",
        title: "PostgreSQL",
        description: "It is an object-relational database management system, developed as an open source project.",
    },
    {
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/laravel.svg",
        title: "Laravel",
        description: "It is a free and open-source PHP framework created by Taylor B. Otwell for the development of web systems that use the MVC standard.",
    },
    {
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/bootstrap.svg",
        title: "Bootstrap",
        description: "Bootstrap is an open-source web framework for developing interface and front-end components for websites and web applications.",
    },
    {
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/primereact.svg",
        title: "PrimeReact",
        description: "A rich set of UI components for React, with over 70 open source components.",
    },
    {
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/material-ui.svg",
        title: "Material UI",
        description: "Material UI is an open source React component library that implements Google's design",
    },
]
